import { Component, Input } from '@angular/core';

@Component({
  selector: 'users-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
  standalone: false,
})
export class CardViewComponent {
  @Input() users: app.models.Users[];
  @Input() props: app.models.DynamicPropsDictionary;

  @Input() deleteUser: any;
  @Input() viewDetails: any;
  @Input() changeUserStatus: any;
  @Input() redirectUserDetails: any;
  @Input() redirectUserRights: any;
}
